// extracted by mini-css-extract-plugin
export default {"container":"schools_container__o1JTn","newSchoolsContainer":"schools_newSchoolsContainer__15EsQ"};